import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BoxRegular from './box-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BoxRegular {...validProps} />;
}
SvgComponent.iconName = 'boxRegular';

export const BoxRegularIcon = svgIconWrapper(SvgComponent);
